<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-claims-view :claimStatuses="claimStatuses" />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ReviewClaims',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreClaimsView: () => import('../components/core/ClaimsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
    claimStatuses: [
        'NEW',
        'ADMIN_REVIEW'
    ]
  }),
}
</script>
